import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Section = styled.section`
  display: grid;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const Head = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${spacing[2]};
`;

export const Heading = styled.h3`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  margin: 0;
  ${typographyMixin("subtitle", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Badge = styled.span`
  display: grid;
  place-items: center;
  width: 1.375rem;
  height: 1.375rem;
  border-radius: ${borderRadius.full};
  background: ${({ theme }) => theme.colors.primary[100]};
  ${typographyMixin("caption", 1)}
  color: ${({ theme }) => theme.colors.primary[500]};
`;

export const Sub = styled.span`
  flex: 1 1 13.75rem;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};

  b,
  strong {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
